import BACKEND_URL from 'constants/backendUrl';
import MultiActionsButton from '../MultiActionsButton';
import { useSessionStore } from 'stores/session';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { POST } from 'utils/http';
import { Civility } from 'core/enums/civility';
import Male from 'images/icons/Male.svg?react';
import Female from 'images/icons/Female.svg?react';
import Button from '../Button';
import { SProfileActions } from './styles';

export const logOutFetcher = async () => {
    try {
        await POST(`${BACKEND_URL}/api/auth/logout`);
    } catch (error) {
        throw new Error('UNKNOWN_ERROR');
    }
};

const ProfileActions: FC = () => {
    const { t } = useTranslation();
    const history = useHistory();

    const user = useSessionStore((s) => s.user);
    const logout = useSessionStore((s) => s.logout);

    if (!user) {
        return null;
    }

    const logOut = async () => {
        try {
            await logOutFetcher();
            logout();
            history.push('/login');
        } catch (error) {
            // maybe store the error in a global state and have a way to display the 'global' errors in every pages
        }
        logout();
    };

    return (
        <SProfileActions>
            <MultiActionsButton
                parentButtonContent={Civility.Female === user.civility ? <Female /> : <Male />}
                iconButton
            >
                <Button onClick={() => history.push('/profile')} variant="popinText">
                    {t('profile.label')}
                </Button>
                <Button onClick={() => history.push('/help')} variant="popinText">
                    {t('help.label')}
                </Button>
                <Button onClick={() => history.push('/legal-notice')} variant="popinText">
                    {t('legal-notice.label')}
                </Button>
                <Button onClick={logOut} variant="popinText">
                    {t('header.logout')}
                </Button>
            </MultiActionsButton>
        </SProfileActions>
    );
};

export default ProfileActions;
